module.exports = __webpack_public_path__ + "img/vertical_layout_3.694553d5.jpg";